import { render, staticRenderFns } from "./InvestorOnboardingBirthData.vue?vue&type=template&id=67f367f9&"
import script from "./InvestorOnboardingBirthData.vue?vue&type=script&lang=js&"
export * from "./InvestorOnboardingBirthData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports